<div class="price-details-view">
  <span>{{paymentMethodFormatted}}</span>&nbsp;
  <span class="initial-price" [ngClass]="{'initial-price--crossed': !!suggestedPrice}">{{price}}$</span>
  <span *ngIf="suggestedPrice"> => {{suggestedPrice}}$</span>
</div>